import Vue from 'vue';
import App from './App.vue';
import './assets/font/iconfont.css';
import router from './router';
import store from "@/store";
import Cookies from "js-cookie";
import { getThousandsNum } from './utils/common'

import {hidden} from "@/utils/hidden";


// Vue.prototype.$globalVar = "http://localhost:8080/";
// Vue.prototype.$globalVar = "https://www.financialfree.cn/";
Vue.prototype.$globalVar = "https://www.ktuofu.cn/";
// Vue.prototype.$globalVar = "http://124.222.137.8/";


// window.$ = $; // 将jQuery挂载到window对象上，以便其他库或脚本可以访问它。

// 注册必须的组件

import {
    Dialog,
    Autocomplete,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Button,
    Input,

    Form,
    FormItem,

    Message,
    MessageBox,
    Spinner,
    Radio,
    RadioGroup
} from 'element-ui';

Vue.use(Dialog);
Vue.use(Autocomplete);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Button);
Vue.use(Input)
Vue.use(Form);
Vue.use(FormItem);


Vue.use(Spinner);
Vue.use(Radio);
Vue.use(RadioGroup);


Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;

Vue.config.productionTip = false;

Vue.filter('formatPrice', getThousandsNum)

Vue.filter('hideAmount', hidden)


//正式版
// router.beforeEach((to, from, next) => {
//     const token = Cookies.get('satoken');
//     if (token && to.name === 'login') {
//         isFirstLogin(token).then((resp) => {
//             if (resp.data === true) {
//                 next({name: 'step'})
//             } else{
//                 // this.$router.push("/product/");
//                 to.query.hold !== 'login' ? next({ name: 'product' }) : next()
//             }
//         })
//
//     }else if (!token && to.name !== 'login' && to.name !== 'register'
//         && to.name !== 'find' && to.name !== 'homepage'
//         && to.name !== 'agreement' && to.name !== 'about'
//         && to.name !== 'contact' && to.name !== 'join'
//         && to.name !== 'price') {
//         // next({name: 'login'})
//         next({name: 'homepage'})
//     }else {
//         next();
//     }
// });

//-----------


new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
    // mounted() {
    //     document.dispatchEvent(new Event('render-event'))
    // },
}).$mount('#app')

